import { render, staticRenderFns } from "./StudyPlansTableCheckbox.vue?vue&type=template&id=696e3ca4&"
import script from "./StudyPlansTableCheckbox.vue?vue&type=script&lang=js&"
export * from "./StudyPlansTableCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports